// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"3bb80f73","379":"49a37b4e"}[chunkId] + ".chunk.css";
};